import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../config/supabase';
import './Pages.css';

// The authorized email - replace with your email
const AUTHORIZED_EMAIL = 'thibault.brun@hympact.ch';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);

  useEffect(() => {
    // Check if user is already logged in
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session && session.user.email === AUTHORIZED_EMAIL) {
        navigate('/esrs-reporting');
      }
    };
    checkUser();
  }, [navigate]);

  const handleSignUp = async (e) => {
    e.preventDefault();
    
    if (email !== AUTHORIZED_EMAIL) {
      setMessage('Access denied. You are not authorized to create an account.');
      return;
    }

    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      setMessage('Password must be at least 6 characters long.');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const { error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) throw error;

      setMessage('Account created successfully! You can now sign in.');
      setIsSignUp(false);
    } catch (error) {
      console.error('Error signing up:', error.message);
      setMessage('Error creating account. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (email !== AUTHORIZED_EMAIL) {
      setMessage('Access denied. You are not authorized to access this application.');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const { error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) throw error;

      // If successful, the useEffect will handle the navigation
    } catch (error) {
      console.error('Error logging in:', error.message);
      setMessage('Error logging in. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img 
          src="/images/hympact-logo.png" 
          alt="Hympact Logo" 
          className="login-logo"
        />
        <h1>Welcome to Hympact</h1>
        <p>Sign in to access the CSRD reporting platform</p>
        
        {message && (
          <div className={`message ${message.includes('Error') || message.includes('denied') ? 'error' : 'success'}`}>
            {message}
          </div>
        )}

        <form onSubmit={isSignUp ? handleSignUp : handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
          />
          {isSignUp && (
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="login-input"
            />
          )}
          <button 
            type="submit" 
            className="login-submit-button" 
            disabled={loading}
          >
            {loading ? 'Processing...' : (isSignUp ? 'Create Account' : 'Sign In')}
          </button>
        </form>

        <button 
          onClick={() => {
            setIsSignUp(!isSignUp);
            setMessage('');
            setPassword('');
            setConfirmPassword('');
          }}
          className="toggle-auth-button"
        >
          {isSignUp ? 'Already have an account? Sign In' : 'Need to create an account? Sign Up'}
        </button>
      </div>
    </div>
  );
}

export default Login; 